import { Provider } from 'react-redux';
import store, { persistor } from './store';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import history from './history';
import Layout from './components/shared/Layout';
import AppErrorBoundary from './components/shared/AppErrorBoundary';
import { Helmet } from 'react-helmet';

const App = () => {
  return (
    <>
      <Helmet>
        <meta httpEquiv="cache-control" content="no-cache" />
        <meta httpEquiv="expires" content="0" />
        <meta httpEquiv="pragma" content="no-cache" />
      </Helmet>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <BrowserRouter history={history}>
            <AppErrorBoundary>
              <Layout />
            </AppErrorBoundary>
          </BrowserRouter>
        </PersistGate>
      </Provider>
    </>
  );
};

export default App;
